import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { EventSource } from '@/models/event-source.model';

type ServerEventSource = EventSource & { languages: string };

class EventSourceService extends BaseService {
  private url: string = '/api/event-source';

  constructor() {
    super();
  }

  public async create(item: EventSource): Promise<DataResponse<EventSource>> {
    const res = await this.$http.post<EventSource>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async update(item: EventSource): Promise<DataResponse<EventSource>> {
    const res = await this.$http.put<EventSource>(
      `${this.url}/${item.id}`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async publish(
    id: number,
    published: boolean,
  ): Promise<DataResponse<EventSource>> {
    const res = await this.$http.put<EventSource>(`${this.url}/publish`, {
      id,
      published,
    });

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async get(id: number): Promise<DataResponse<EventSource>> {
    const res = await this.$http.get<ServerEventSource>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: Object.assign(res.data, {
        languages: (res.data.languages as string)
          .split(',')
          .filter((v: string) => !!v),
      }),
    };
  }

  public async getList(): Promise<DataResponse<EventSource[]>> {
    const res = await this.$http.get<ServerEventSource[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }

  public async upload(csv: File): Promise<DataResponse<EventSource[]>> {
    const data = new FormData();
    data.append('file', csv);

    const res = await this.$http.post<EventSource[]>(
      `${this.url}/upload`,
      data,
      true,
    );
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }
}

export default new EventSourceService();
